import { render, staticRenderFns } from "./modalEditAttributes.vue?vue&type=template&id=791fae3c&"
import script from "./modalEditAttributes.vue?vue&type=script&lang=js&"
export * from "./modalEditAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports